<template>
  <div class="offline">
    <div>
      <h1 class="title is-">
        {{ $route.params.domain || "Dieser CloudConf-Server" }} ist zur Zeit
        deaktiviert.
      </h1>
      <h2 class="title is-6">
        Der Konferenzserver <em>{{ $route.params.domain }}</em> ist zur Zeit
        nicht erreichbar. Bitte deinen Administrator, ihn für dich einzuschalten
        oder warte ggf. noch ein paar Minuten.
        <router-link to="/"> Mehr Erfahren &rarr;</router-link>
      </h2>
      <h2 class="title is-5">
        <router-link to="/konto/server">
          <img
            src="@/assets/logo.svg"
            alt="ConfCloud"
            style="height:.9em;margin:0 .75rem 0 .5rem;"
          />Jetzt aktivieren</router-link
        >
      </h2>
    </div>
  </div>
</template>

<script>
export default {
  name: "ServerOffline"
};
</script>

<style scoped lang="scss">
.offline {
  margin: 0 auto;
  max-width: 50rem;
  height: 75vh;
  /* width: 100%; */
  display: flex;
  /* justify-content: center; */
  align-items: center;

  .title.is-6 {
    line-height: 1.6;
  }
}
</style>
